class cOptionsMetadata {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elBtnSaveMetadataOptions = $("#edit-metadata-options-submit-btn");
        this.elMetadataOptionsEditForm = $('#metadata-form');
        $(elBtnSaveMetadataOptions).click(function (e) { return self.submitMetadataOptions(this, e); });
    }
    submitMetadataOptions(btn, e) {
        $(btn).button('loading');
        $(this.elMetadataOptionsEditForm).ajaxSubmit({
            url: URL_ADMIN + '/sourcesdb/updatedefaultmetadata/',
            type: 'post',
            dataType: 'json',
            data: {},
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                }
                else {
                    notify.error(response.errors[0]);
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
    }
}
